<div *ngIf="isSuspended">
  <div class="mb24 error-section">
    <span class="icon-container" id="fpSuspendedIcon">
      <img alt="Alert" aria-hiddden="true" class="pb10 mr10 float-left red-cross-error-icon"
        src="ocsp-web-ui/dist/assets/images/Warning.svg" />
    </span>

    <div *ngIf="suspendedGovAssistance; else defaultSuspended">
      <span aria-live="polite" class="error-prompt" id="freshPassSuspended">
        {{ suspendedGovElibilityText }}
        <a (click)="redirectToSnapVerification()" (keydown.enter)="redirectToSnapVerification()" class="error-message"
          role="link" tabindex="0">
          {{ govAssistanceElibilityText }}</a>
      </span>
    </div>
    <ng-template #defaultSuspended>
      <span aria-live="polite" class="error-prompt" id="freshPassSuspended">
        Your FreshPass plan is currently disabled due to an issue with your
        payment method. Please update your
        <a (click)="redirectToPayments()" (keydown.enter)="redirectToPayments()" class="error-message" role="button"
          tabindex="0">
          payment method</a>.
      </span>
    </ng-template>
  </div>
</div>
<div *ngIf="!hasCoupons && !isSuspended">
  <div aria-live="polite" class="fs22-text pb40" data-testid="freshPassWelcome" id="freshPassWelcome">
    Welcome to FreshPass! Thanks for signing up, your perks are on the way. If
    you've redeemed them all, check back soon.
  </div>
</div>